import React from 'react';
import './Loading.css'; // Import the CSS styling

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-text">Loading your dashboard...</p>
    </div>
  );
};

export default Loading;
